import { render } from "./CardFrame.vue?vue&type=template&id=1938b102"
import script from "./CardFrame.vue?vue&type=script&lang=js"
export * from "./CardFrame.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__